import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { GlobalStyles } from '@mui/material';
import theme from './theme';
import { UserProvider } from './context/UserContext';
import RequireAuth from './components/RequireAuth';
import TermosUsoCheck from './components/TermosUsoCheck';
import DataNascimentoCheck from './components/DataNascimentoCheck';
import Login from './pags/Login';
import Home from './pags/Home';
import UnidadesDistribuidoras from './pags/UnidadesDistribuidoras';
import Distribuidora from './pags/Distribuidora';
import DistribuidoraCad from './pags/Distribuidora/DistribuidoraCad';
import Fornecedores from './pags/Fornecedores';
import FornecedoresCad from './pags/Fornecedores/FornecedoresCad';
import Solicitacoes from './pags/Solicitacoes';
import Clientes from './pags/Clientes';
import ClientesCad from './pags/Clientes/ClientesCad';
import Usuarios from './pags/Usuarios';
import UsuariosCad from './pags/Usuarios/UsuariosCad';
import EntradaProdutos from './pags/EntradaProdutos';
import EntradaProdutosCad from './pags/EntradaProdutos/EntradaProdutosCad';
import OrdemProducao from './pags/OrdemProducao';
import OrdemProducaoCad from './pags/OrdemProducao/OrdemProducaoCad';
import Vendas from './pags/Vendas';
import VendasCad from './pags/Vendas/VendasCad';
import RomaneioVendas from './pags/Vendas/RomaneioVendas';
import Rastreabilidade from './pags/Rastreabilidade';
import Estoque from './pags/Estoque';
import Tag from './pags/Tag';
import Coletas from './pags/Coletas';
import WhatsApp from './pags/WhatsApp';
import Relatorios from './pags/Relatorios';
import Configuracoes from './pags/Configuracoes';
import Atualizacoes from './pags/Atualizacoes';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={{
        '*:focus-visible': {
          outline: 'none !important',
          outlineOffset: '0 !important',
        },
      }} />
      <UserProvider>
        <Router>
          <div className="App">
            {/* Fora das rotas: cobra o aceite dos termos em qualquer tela. */}
            <TermosUsoCheck />
            {/* Depois dos termos, para ficar por cima: sem a data não segue. */}
            <DataNascimentoCheck />
            <Routes>
          <Route path="/" element={<Login />} />
          {/* Portal público: quem lê o QR Code não tem login. */}
          <Route path="/rastreabilidade" element={<Rastreabilidade />} />
          <Route
            path="/home"
            element={
              <RequireAuth requireUnidade>
                <Home />
              </RequireAuth>
            }
          />
          <Route
            path="/unidades"
            element={
              <RequireAuth requireUnidade>
                <UnidadesDistribuidoras />
              </RequireAuth>
            }
          />
          <Route
            path="/atualizacoes"
            element={
                <Atualizacoes />
            }
          />

          {/* Rotas de Cadastros */}
          <Route
            path="/distribuidora"
            element={
              <RequireAuth>
                <Distribuidora />
              </RequireAuth>
            }
          />
          <Route
            path="/distribuidora/cadastro"
            element={
              <RequireAuth>
                <DistribuidoraCad />
              </RequireAuth>
            }
          />
          <Route
            path="/distribuidora/cadastro/:id"
            element={
              <RequireAuth>
                <DistribuidoraCad />
              </RequireAuth>
            }
          />
          <Route
            path="/fornecedores"
            element={
              <RequireAuth requireUnidade>
                <Fornecedores />
              </RequireAuth>
            }
          />
          <Route
            path="/solicitacoes"
            element={
              <RequireAuth requireUnidade>
                <Solicitacoes />
              </RequireAuth>
            }
          />
          <Route
            path="/fornecedores/solicitacoes"
            element={
              <RequireAuth requireUnidade>
                <Solicitacoes />
              </RequireAuth>
            }
          />
          <Route
            path="/fornecedores/cadastro"
            element={
              <RequireAuth requireUnidade>
                <FornecedoresCad />
              </RequireAuth>
            }
          />
          <Route
            path="/fornecedores/cadastro/:id"
            element={
              <RequireAuth requireUnidade>
                <FornecedoresCad />
              </RequireAuth>
            }
          />
          <Route
            path="/clientes"
            element={
              <RequireAuth requireUnidade>
                <Clientes />
              </RequireAuth>
            }
          />
          <Route
            path="/clientes/cadastro"
            element={
              <RequireAuth requireUnidade>
                <ClientesCad />
              </RequireAuth>
            }
          />
          <Route
            path="/clientes/cadastro/:id"
            element={
              <RequireAuth requireUnidade>
                <ClientesCad />
              </RequireAuth>
            }
          />
          <Route
            path="/usuarios"
            element={
              <RequireAuth requireUnidade>
                <Usuarios />
              </RequireAuth>
            }
          />
          <Route
            path="/usuarios/cadastro"
            element={
              <RequireAuth requireUnidade>
                <UsuariosCad />
              </RequireAuth>
            }
          />
          <Route
            path="/usuarios/cadastro/:id"
            element={
              <RequireAuth requireUnidade>
                <UsuariosCad />
              </RequireAuth>
            }
          />
          {/* Rotas de Entrada de Produtos / Compras */}
          <Route
            path="/compras"
            element={
              <RequireAuth requireUnidade>
                <EntradaProdutos />
              </RequireAuth>
            }
          />
          <Route
            path="/compras/cadastro"
            element={
              <RequireAuth requireUnidade>
                <EntradaProdutosCad />
              </RequireAuth>
            }
          />
          <Route
            path="/compras/cadastro/:id"
            element={
              <RequireAuth requireUnidade>
                <EntradaProdutosCad />
              </RequireAuth>
            }
          />
          <Route
            path="/entrada-produtos"
            element={
              <RequireAuth requireUnidade>
                <EntradaProdutos />
              </RequireAuth>
            }
          />
          <Route
            path="/entrada-produtos/cadastro"
            element={
              <RequireAuth requireUnidade>
                <EntradaProdutosCad />
              </RequireAuth>
            }
          />
          <Route
            path="/entrada-produtos/cadastro/:id"
            element={
              <RequireAuth requireUnidade>
                <EntradaProdutosCad />
              </RequireAuth>
            }
          />
          {/* Rotas de Ordem de Produção */}
          <Route
            path="/ordem-producao"
            element={
              <RequireAuth requireUnidade>
                <OrdemProducao />
              </RequireAuth>
            }
          />
          <Route
            path="/ordem-producao/cadastro"
            element={
              <RequireAuth requireUnidade>
                <OrdemProducaoCad />
              </RequireAuth>
            }
          />
          <Route
            path="/ordem-producao/cadastro/:id"
            element={
              <RequireAuth requireUnidade>
                <OrdemProducaoCad />
              </RequireAuth>
            }
          />
          {/* Rotas de Vendas */}
          <Route
            path="/vendas"
            element={
              <RequireAuth requireUnidade>
                <Vendas />
              </RequireAuth>
            }
          />
          <Route
            path="/vendas/cadastro"
            element={
              <RequireAuth requireUnidade>
                <VendasCad />
              </RequireAuth>
            }
          />
          <Route
            path="/vendas/cadastro/:id"
            element={
              <RequireAuth requireUnidade>
                <VendasCad />
              </RequireAuth>
            }
          />
          <Route
            path="/vendas/romaneio/:id"
            element={
              <RequireAuth requireUnidade>
                <RomaneioVendas />
              </RequireAuth>
            }
          />
          {/* Rota de Estoque */}
          <Route
            path="/estoque"
            element={
              <RequireAuth requireUnidade>
                <Estoque />
              </RequireAuth>
            }
          />
          {/* Rotas de Etiquetas */}
          <Route
            path="/etiquetas"
            element={
              <RequireAuth requireUnidade>
                <Tag />
              </RequireAuth>
            }
          />
          <Route
            path="/etiquetas/:id"
            element={
              <RequireAuth requireUnidade>
                <Tag />
              </RequireAuth>
            }
          />
          {/* Rotas de Coletas */}
          <Route
            path="/coletas"
            element={
              <RequireAuth requireUnidade>
                <Coletas />
              </RequireAuth>
            }
          />
          {/* Rota do WhatsApp */}
          <Route
            path="/whatsapp"
            element={
              <RequireAuth requireUnidade>
                <WhatsApp />
              </RequireAuth>
            }
          />
          {/* Rotas de Relatórios */}
          <Route
            path="/relatorios"
            element={
              <RequireAuth requireUnidade>
                <Relatorios />
              </RequireAuth>
            }
          />
          {/* Conta do usuário logado — não depende de unidade selecionada. */}
          <Route
            path="/configuracoes"
            element={
              <RequireAuth>
                <Configuracoes />
              </RequireAuth>
            }
          />
            </Routes>
          </div>
        </Router>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;
